import type { GemxQlQueryResponse, GemxQlQueryVariables } from '~/core/gemxql/graphql';
import type { IOrder } from '../types';

import { useCampaignTemplateListing } from '~/modules/campaign-template';
import { useGemxQlNamedQuery } from '~/core/gemxql/api';

const DEFAULT_NAME = 'OrderListingQL';

export const useQueryOrderListing = ({
  variables,
  enabled = true,
  name = DEFAULT_NAME,
}: {
  variables: GemxQlQueryVariables;
  enabled?: boolean;
  name?: string;
}) => {
  const { data: campaignTemplates } = useCampaignTemplateListing();
  const { data, isLoading, isFetching, error, refetch } = useGemxQlNamedQuery(
    { name, variables },
    {
      enabled: !!variables.input && enabled,
      retry: false,
      keepPreviousData: true,
    },
  );

  return {
    data: convertFn(data),
    total: data?.gemxQLQuery?.tableData?.rows?.[0]?.orders,
    isLoading,
    isFetching,
    error,
    refetch,
  };

  function convertFn(data: GemxQlQueryResponse | undefined): IOrder[] {
    if (!data) return [];

    return (
      data.gemxQLQuery?.tableData?.rows?.map((item) => {
        return {
          ...item,
          experiment_id: campaignTemplates.find((template) => template.id === item.experiment_id)
            ?.name,
        };
      }) ?? []
    );
  }
};
